import moment from "moment";

export class GetManagementFarmDapUseCase {
  constructor(farmsDapRepository, logSectorRepository) {
    this.farmsDapRepository = farmsDapRepository;
    this.logSectorRepository = logSectorRepository;
  }
  //SECTOR -> CROP.CAD_SECTOR
  /**
   * OBS:VOLUME => Primeiro registro de volume calculado da válvula no cadastro de setor
   */
  async execute({
    ID_FARM,
    ID_SECTOR,
    VOLUME,
    PLANTING_DATE,
    DATE_CROP,
    VOLUME_DATE
  }) {
    const farmDAPs = await this.farmsDapRepository.getOrderedFarmDapById(
      ID_FARM
    );

    const sectorLogs = await this.logSectorRepository.getSectorLogByIdSector(
      ID_SECTOR
    );

    const firstVolumeLogTime = VOLUME_DATE || VOLUME.TIME;
    const today = moment();
    let harvestDate;
    let fromWateringToHarvestInDays;

    if (DATE_CROP) {
      harvestDate = moment(DATE_CROP);
    }

    if (harvestDate) {
      fromWateringToHarvestInDays =
        harvestDate.diff(firstVolumeLogTime, "days") + 1;
    }

    const plantingDate = moment(moment(PLANTING_DATE).format("YYYY-MM-DD"));

    const firstVolumeToTodayInDays = today.diff(firstVolumeLogTime, "days");
    const firstDayDiffPlantingDate =
      plantingDate.diff(firstVolumeLogTime, "days") - 1;
    const firstDayDap =
      firstDayDiffPlantingDate < 0 ? -1 * firstDayDiffPlantingDate : 0;

    let limitatiorResponses =
      harvestDate && fromWateringToHarvestInDays < firstVolumeToTodayInDays
        ? fromWateringToHarvestInDays
        : firstVolumeToTodayInDays + 1;

    let items =
      limitatiorResponses <= 0
        ? []
        : [...Array(limitatiorResponses).keys()]
            .map(item => {
              item = {};

              return item;
            })
            .map((item, index, arrayItems) => {
              const volumeLogTimeLoop = moment(firstVolumeLogTime);

              const time = volumeLogTimeLoop
                .add(index, "DAYS")
                .format("YYYY-MM-DD");

              const indexOfFirstLogAfterTime = sectorLogs.findIndex(
                sectorLog => {
                  return moment(sectorLog.TIME).isAfter(
                    moment(time)
                      .subtract(1, "days")
                      .format("YYYY-MM-DD")
                  );
                }
              );

              let supposedOffset;

              if (sectorLogs.length && indexOfFirstLogAfterTime > 0) {
                supposedOffset =
                  sectorLogs[indexOfFirstLogAfterTime - 1].OFFSET;
              } else if (sectorLogs.length) {
                supposedOffset = sectorLogs[sectorLogs.length - 1].OFFSET;
              } else {
                supposedOffset = 0;
              }

              //E se o indexOfFirstLogAfterTime for 0, vai ficar -1 e não irá conseguir pegar um valor caso a condição for >=0
              /*let supposedOffset = indexOfFirstLogAfterTime > 0 ?
          sectorLogs[indexOfFirstLogAfterTime - 1].OFFSET
          : 0;*/

              // debugger

              let supposedDAP =
                index > 0 ? arrayItems[index - 1].DAP + 1 : firstDayDap;

              let dap = supposedDAP + supposedOffset;

              if (dap > farmDAPs.length - 1) {
                dap = farmDAPs.length - 1;
              }

              if (moment(time).isBefore(PLANTING_DATE)) {
                dap = 0;
              }

              item.TIME = time;
              item.OFFSET = supposedOffset;
              item.DAP = dap;

              return {
                ...item,
                ...farmDAPs.find(farmDAP => farmDAP.DAP === dap)
              };
            });

    return items;
  }
}
